// info/sections/conversationsAdminView.jsx
import React from 'react';
import {
  Box,
  CircularProgress,
  Backdrop,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Avatar,
  Typography,
} from '@mui/material';
import { useQuery } from 'react-query';
import API from '../../../../../API';

const ConversationsAdminView = () => {
  const {
    data: convos,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery('adminConversations', () => API.conversations.fetchAdmin(), {
    refetchOnWindowFocus: false,
  });

  if (isLoading)
    return (
      <Backdrop open>
        <CircularProgress color="inherit" />
      </Backdrop>
    );

  if (isError)
    return (
      <Box p={4}>
        <Typography color="error">{error?.message || 'Error!'}</Typography>
      </Box>
    );

  return (
    <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
      <Table>
        <TableHead sx={{ bgcolor: '#1976d2' }}>
          <TableRow>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>ID</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Cover</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Name</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Host</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }} align="right">
              Participants
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Status</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Created</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {convos.map((c) => (
            <TableRow key={c.id} hover>
              <TableCell>{c.id}</TableCell>
              <TableCell>
                {c.header_media_url ? (
                  <Avatar
                    variant="rounded"
                    src={c.header_media_url}
                    sx={{ width: 56, height: 38 }}
                  />
                ) : (
                  <Avatar
                    variant="rounded"
                    sx={{ width: 56, height: 38, bgcolor: 'grey.300' }}
                  />
                )}
              </TableCell>
              <TableCell>{c.display_name || `Conversation #${c.id}`}</TableCell>
              <TableCell>
                {c.creator?.pfphref ? (
                  <Avatar
                    src={c.creator.pfphref}
                    sx={{ width: 32, height: 32, mr: 1 }}
                  />
                ) : (
                  <Avatar sx={{ width: 32, height: 32, mr: 1 }} />
                )}
                {c.creator?.display_name || c.creator?.username || '—'}
              </TableCell>
              <TableCell align="right">{c.participant_count}</TableCell>
              <TableCell>{c.status}</TableCell>
              <TableCell>
                {c.created_at
                  ? new Date(c.created_at).toLocaleDateString()
                  : '—'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ConversationsAdminView;
